import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ConfirmationDialog from "../ui/ConfirmationDialog";
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();

class RefundAndTerminateDialog extends Component {
  

  render() {

    const { isAuthenticatedCustomer, isUnauthenticatedCustomer } = this.props.auth;

    if (!isAuthenticatedCustomer() && !isUnauthenticatedCustomer()) {
      return null;
    }

    return (
      <ConfirmationDialog
        open={this.props.open}
        onClose={this.props.onClose}
        onConfirm={ () => this._requestCancel(this.props) }
        onCancel={this.props.onClose}
        irreversibleAction={true}
        title="Refund balance and terminate agreeement"
        cancelBtn="No"
        okBtn="Yes"
      >
        {/* {"Close your account with $Reseller.name and refund your remaining balance. New expenses will be automatically declined.\n\nIf you’d like to transfer subscriptions under your control or get a partial refund, email support.\n mailto:support@appbind.com \n\nAre you sure you want to cancel your account?"} */}
        Close your account with { this.props.account?.accountTByParentId?.accountName != null ? this.props.account.accountTByParentId.accountName : 'AppBind'} and refund your remaining balance. New expenses will be automatically declined.
        <br/><br/>
        If you’d like to transfer subscriptions under your control or get a partial refund, email support.<br/>
        <a href="mailto:support@appbind.com">support@appbind.com</a>
        <br/><br/>
        Are you sure you want to cancel your account?
      </ConfirmationDialog>
    );
  }

  /**
   * Call appbind api to process cancel customer account per reseller.
   * @param {Object} props Properties passed to the component; should contain "setSaveSpinner" function to 
   *    reflect the call is being processed on page containing the dialog with some spinner.
   */
  _requestCancel(props) {
    const { callPartnerApi, isAuthenticatedCustomer, isUnauthenticatedCustomer } = props.auth;
    
    //guard clause; currently restrict non-customer
    if (!isAuthenticatedCustomer() && !isUnauthenticatedCustomer()) {
      return;
    }

    //extra protection, only allow cancel if you are the account
    if (abEnvironment.getUserAttribute("a_id") !== props.account.accountId) {
      return;
    }

    if (props.setSaveSpinner)
      props.setSaveSpinner(true); 


    let accountId = props.account.accountId;
    let pAccountId = props.account.accountTByParentId.accountId;
  
    let payload = {
      operation: "customerCancelAccount",
      params: {
        accountId:   accountId,
        pAccountId:  pAccountId
      }
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then(response => {
      return response.json();
    })
    .then(result => {
      if (result.data.status !== "success") {
        throw result;
      } else {
        if (props.setSaveSpinner)
          props.setSaveSpinner(false);
        window.location.reload();
      }
    })
    .catch(error => {
      // console.log('Got error: ' + error);
      if (props.setSaveSpinner)
        props.setSaveSpinner(false);
    });
  }
}

RefundAndTerminateDialog.propTypes = {
  auth: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
};

export default RefundAndTerminateDialog;